import Button$1 from './variants/Button.es.js';
import LinkButton from './variants/Link.es.js';

const Button = Button$1;
Button.Link = LinkButton;

export { Button, Button as default };
//# sourceMappingURL=Button.es.js.map
